import { addJitter, createExponentialRetryStrategy, withRetries } from '@genially/utils';

import { P2pRestClient } from '../services/P2pRestClient';

export const waitUntilServerIsAlive = async (value: string): Promise<void> => {
  await withRetries(
    async () => {
      const isAlive = await P2pRestClient.with(value).isAlive();

      if (!isAlive) {
        throw new Error('Server is not alive');
      }
    },
    addJitter(
      createExponentialRetryStrategy({
        step: 1000,
        max: 4000,
        multiplier: 2,
        shouldRetryError() {
          return true;
        },
      }),
      {
        min: 0.5,
        max: 1,
      },
    ),
    false,
  );
};
